import go from 'gojs';
import { formatDate } from 'react-day-picker/moment';
import { apiGet, getHostApi } from '../../../apiWrapper';
import { _emptyIfNull } from "../../common/functions";
import { _showLinkTooltip, tooltipsActions } from "../../tooltips/actions";
import { diagram } from '../initial';
import { VISIBILITY_TYPE } from '../../common/constants';
import { isNullOrUndefined } from '../../../storeFunctions';

//############# link template ##############//
function createLinkTemplateMap(dispatch) {
    let map = new go.Map();
    map.add('', _createLinkTemplate(go.GraphObject.make, dispatch));
    map.add('merge', go.GraphObject.make(go.Link,
        { layerName: 'merge' },
        go.GraphObject.make(go.Shape, { stroke: "#77777b" })
    ));
    return map;
}

function _createLinkTemplate($, dispatch) {
    return $(go.Link,
        {
            selectionAdornmentTemplate: go.GraphObject.make(go.Adornment,
                go.GraphObject.make(go.Shape, { isPanelMain: true, figure: "none", stroke: "orange", strokeWidth: 5, opacity: 1 })
            ),
            layerName: "Background",
        },
        new go.Binding("toEndSegmentLength", "GraphType", function (lnk, obj) { return lnk === "star" ? 0 : 60; }),
        new go.Binding("fromEndSegmentLength", "GraphType", function (lnk, obj) { return lnk === "star" ? 0 : 60; }),
        new go.Binding("visible", "", function (lnk, obj) { return isNullOrUndefined(lnk.Visibility) || lnk.Visibility === VISIBILITY_TYPE.visible }),
        $(go.Shape,
            { strokeCap: "round", strokeWidth: 2 },
            new go.Binding("strokeDashArray", "State", function (state) { return state === 0 ? [0, 0] : [6, 6, 2, 2]; }),
            new go.Binding("stroke", "", function (lnk) { return _getLinkColor(lnk); })
        ),
        $(go.Shape,
            { scale: 1.5, stroke: "#3f3f3e" },
            new go.Binding("fromArrow", "", function (lnk, x) {
                if ((["NR03", "NRZV", "NR0K", "NRSS", "NR08", "NRCU", "NR0H", "NRFU"].indexOf(lnk.RootGroupId) !== -1) && lnk.Polarity > 0)
                    return "BackwardTriangle";

                var child = x.diagram.model.nodeDataArray.filter(function (x) { return x.EntityID === lnk.ChildID });
                var parent = x.diagram.model.nodeDataArray.filter(function (x) { return x.EntityID === lnk.ParentID });
                var notRelationWithFo = child.length === 1 && parent.length === 1 && (!(child[0].Type !== "Person" && parent[0].Type === "Person")
                    && !(child[0].Type === "Person" && parent[0].Type !== "Person"));
                var showArrow = (["NR03", "NRZV", "NR0K", "NRSS", "NR08", "NRCU", "NR0H", "NRFU"].indexOf(lnk.RootGroupId) !== -1)
                    || ((["NR02", "NR01", "NRBO", "NRNA"].indexOf(lnk.RootGroupId) !== -1) && notRelationWithFo);

                var fromArrow = lnk.Polarity > 0 ? "BackwardTriangle" : "Circle";
                fromArrow = showArrow ? fromArrow : "Circle";

                return lnk.Guaranteed === 2 && fromArrow === "Circle" ? '' : fromArrow;
            }),
            new go.Binding("fill", "Guaranteed", function (relationReliabilityId) { return _getShapeFillColor(relationReliabilityId); })
        ),
        $(go.Shape,
            { scale: 1.5, stroke: "#3f3f3e" },
            new go.Binding("toArrow", "", function (lnk, x) {
                if ((["NR03", "NRZV", "NR0K", "NRSS", "NR08", "NRCU", "NR0H", "NRFU"].indexOf(lnk.RootGroupId) !== -1) && lnk.Polarity < 0)
                    return 'Standard';

                var child = x.diagram.model.nodeDataArray.filter(function (x) { return x.EntityID === lnk.ChildID });
                var parent = x.diagram.model.nodeDataArray.filter(function (x) { return x.EntityID === lnk.ParentID });
                var notRelationWithFo = child.length === 1 && parent.length === 1 && (!(child[0].Type !== "Person" && parent[0].Type === "Person")
                    && !(child[0].Type === "Person" && parent[0].Type !== "Person"));
                var showArrow = (["NR03", "NRZV", "NR0K", "NRSS", "NR08", "NRCU", "NR0H", "NRFU"].indexOf(lnk.RootGroupId) !== -1)
                    || ((["NR02", "NR01", "NRBO", "NRNA"].indexOf(lnk.RootGroupId) !== -1) && notRelationWithFo);

                var toArrow = lnk.Polarity < 0 ? 'Standard' : "Circle";
                toArrow = showArrow ? toArrow : "Circle";

                return lnk.Guaranteed === 2 && toArrow === "Circle" ? '' : toArrow;
            }),
            new go.Binding("fill", "Guaranteed", function (relationReliabilityId) { return _getShapeFillColor(relationReliabilityId); })
        ),
        $(go.Panel, "Auto", // this whole Panel is a link label
            {
                name: "label",
                visible: true,
                segmentOffset: new go.Point(0, 0),
                segmentOrientation: go.Link.OrientUpright
            },
            $(go.Shape,
                { fill: "white", stroke: "white" }
            ),
            $(go.TextBlock,
                {
                    font: "bold 13pt Open Sans",
                    margin: 3,
                    stroke: '#3f3f3e',
                    background: "white"
                },
                new go.Binding("text", "", function (linkData) {
                    var percentage = linkData.SharePct !== null && linkData.SharePct !== '' ? '(' + linkData.SharePct + '%)' : "";
                    var text = linkData.RootRelationShortening;
                    if (linkData.RelationsData != null && linkData.RelationsData !== undefined) {
                        text = text + ' (';
                        for (var i = 0; i < linkData.RelationsData.length; i++) {
                            text = text + _emptyIfNull(linkData.RelationsData[i].RelationShortening);
                            if (i !== linkData.RelationsData.length - 1) {
                                text = text + ' ';
                            }
                        }
                        text = text + ') ';
                    }
                    return text + percentage;
                }))
        ),
        {
            mouseHover: function (e, node) { _showLinkTooltip(node.data, node.part.diagram, e.event, dispatch); },
            mouseLeave: function () { dispatch({ type: tooltipsActions.LINK_TOOLTIP.HIDE }); },
            doubleClick: function (e, link) { _linkDoubleClick(e, link) }
        }
    );
}

function _getLinkColor(lnk) {
    if (lnk.RootGroupId === "NRCU") return "#c185ec";
    else if (lnk.State === 0) return "#023671"
    else return "#71b7e6";
}

function _getShapeFillColor(relationReliabilityId) {
    switch (relationReliabilityId) {
        case 1: return "#3f3f3e";
        case 2: return "#919090";
        case 0: return "#ffffff";
        default: return "#ffffff";
    }
}

function _linkDoubleClick(link, linkData) {
    if (linkData.data.RootGroupId === "NRCU") {
        var relData = linkData.data.RelationsData[0];
        apiGet(`${getHostApi()}/api/charts/custom-relation`, { relationId: relData.RelationID }, data => {
            data.RelationID = relData.RelationID;
            data.CurrentUser = relData.UserId === diagram._currentUser.id;
            data.CurrentUserId = diagram._currentUser.id;
            data.RelationShortening = relData.RelationShortening || '';

            var parent = link.diagram.findNodeForKey(linkData.data.ParentID);
            var child = link.diagram.findNodeForKey(linkData.data.ChildID);
            data.subjectOptions =
                [{ label: parent.data.Name, value: parent.data.EntityID },
                { label: child.data.Name, value: child.data.EntityID }];

            if (relData.Polarity > 0) {
                data.SubjectFrom = child.data.EntityID;
                data.SubjectTo = parent.data.EntityID;
            } else {
                data.SubjectFrom = parent.data.EntityID;
                data.SubjectTo = child.data.EntityID;
            }
            data.data.BidirectionalRelation = relData.Polarity === 0;
            data.Polarity = relData.Polarity;
            data.StartDate = relData.StartDate ? formatDate(relData.StartDate, 'DD.MM.YYYY', 'cs') : null;
            data.EndDate = relData.EndDate ? formatDate(relData.EndDate, 'DD.MM.YYYY', 'cs') : null;
            data.SharePct = relData.SharePct || '';
            data.Deposit = relData.Deposit || '';
            data.Currency = relData.Currency || '';
            data.RelationSource = relData.RelationSource || '';
            data.originParentEntityId = parent.data.EntityID;
            diagram._showCustomRelationPopupFunc('edit', data);
        });
    }
}

export { createLinkTemplateMap };
